import { Db } from '../';
export var sleep = function (ms) {
    if (ms === void 0) { ms = 0; }
    return new Promise(function (r) { return setTimeout(r, ms); });
};
var counters = {};
export var autoCount = function (domain) {
    if (domain === void 0) { domain = 'any'; }
    if (!counters[domain]) {
        counters[domain] = 0;
    }
    return counters[domain]++;
};
var wsList = {};
export function getWsInstance(db) {
    if (!Db.wsClientClass) {
        throw new Error('to use realtime you must import realtime module first');
    }
    var env = db.config.env;
    if (!wsList[env]) {
        wsList[env] = new Db.wsClientClass({
            context: {
                appConfig: {
                    docSizeLimit: 1000,
                    realtimePingInterval: 10000,
                    realtimePongWaitTimeout: 5000,
                    request: new Db.reqClass(db.config)
                }
            }
        });
    }
    return wsList[env];
}
